import { render, staticRenderFns } from "./ImportTransactionsView.vue?vue&type=template&id=2db39735&"
import script from "./ImportTransactionsView.vue?vue&type=script&lang=js&"
export * from "./ImportTransactionsView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports